import React, { useState, useEffect } from 'react';
import { Switch, Card, Typography, message, Space, Button } from 'antd';
import { MailOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

const { Title, Text } = Typography;

const NewsletterSubscription = () => {
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    // Получаем текущий статус подписки из профиля пользователя
    if (user && user.newsletterSubscribed !== undefined) {
      setSubscribed(user.newsletterSubscribed);
      return;
    }
    // Пытаемся считать из localStorage (для клиентского кабинета)
    try {
      const clientData = localStorage.getItem('clientData');
      if (clientData) {
        const parsed = JSON.parse(clientData);
        if (typeof parsed.newsletterSubscribed === 'boolean') {
          setSubscribed(parsed.newsletterSubscribed);
        }
      }
    } catch (e) {}
  }, [user]);

  const handleToggle = async (checked) => {
    setLoading(true);

    try {
      const isClient = user?.type === 'client' || !!localStorage.getItem('clientToken');
      const endpoint = isClient 
        ? 'https://limitverify.ru:5000/api/client/newsletter/toggle' 
        : 'https://limitverify.ru:5000/api/auth/newsletter/toggle';
      const token = localStorage.getItem('clientToken') || localStorage.getItem('token');

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        },
        body: JSON.stringify({ subscribed: checked }),
      });

      const data = await response.json();

      const updateLocalStorage = (value) => {
        try {
          const raw = localStorage.getItem('clientData');
          if (raw) {
            const parsed = JSON.parse(raw);
            parsed.newsletterSubscribed = value;
            localStorage.setItem('clientData', JSON.stringify(parsed));
          }
        } catch (e) {}
      };

      if (response.ok) {
        setSubscribed(checked);
        updateLocalStorage(checked);
        message.success(
          checked 
            ? 'Вы успешно подписались на рассылку' 
            : 'Вы отписались от рассылки'
        );
      } else {
        message.error(data.error || 'Произошла ошибка');
      }
    } catch (err) {
      message.error('Произошла ошибка при изменении подписки');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card 
      title={
        <Space>
          <MailOutlined />
          <span>Рассылка</span>
        </Space>
      }
      style={{ marginBottom: 16 }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <Title level={5} style={{ margin: 0 }}>
            Email рассылка
          </Title>
          <Text type="secondary">
            Получать уведомления о новых продуктах, акциях и важных обновлениях
          </Text>
        </div>
        
        <div style={{ textAlign: 'right' }}>
          <Switch
            checked={subscribed}
            onChange={handleToggle}
            loading={loading}
            checkedChildren={<CheckCircleOutlined />}
            unCheckedChildren={<CloseCircleOutlined />}
          />
          <div style={{ marginTop: 8 }}>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {subscribed ? 'Подписан' : 'Не подписан'}
            </Text>
          </div>
        </div>
      </div>

      {subscribed && (
        <div style={{ 
          marginTop: 16, 
          padding: 12, 
          backgroundColor: '#f6ffed', 
          border: '1px solid #b7eb8f',
          borderRadius: 6
        }}>
          <Space>
            <CheckCircleOutlined style={{ color: '#52c41a' }} />
            <Text style={{ color: '#52c41a' }}>
              Вы подписаны на email рассылку. Мы будем отправлять вам только важные уведомления.
            </Text>
          </Space>
        </div>
      )}

      {!subscribed && (
        <div style={{ 
          marginTop: 16, 
          padding: 12, 
          backgroundColor: '#fff2e8', 
          border: '1px solid #ffbb96',
          borderRadius: 6
        }}>
          <Space>
            <CloseCircleOutlined style={{ color: '#fa8c16' }} />
            <Text style={{ color: '#fa8c16' }}>
              Вы не подписаны на рассылку. Включите уведомления, чтобы не пропустить важные обновления.
            </Text>
          </Space>
        </div>
      )}
    </Card>
  );
};

export default NewsletterSubscription;
